<template>
    <div>
        <l-card-headline>
            {{ $t("profile.goals.title") }}
        </l-card-headline>

        <l-tab-navigation :tabs="tabs" :selected.sync="selectedTab" @tabSelect="onTabSelect" />

        <div>
            <l-skeleton-loader v-if="isLoading" />

            <div v-else-if="!goals.length" class="tw-text-gray-400">
                {{ $t("profile.goals.empty") }}
            </div>

            <l-goals-list v-else :goals="goals" />
            <!-- KR edit modal -->
            <l-goal-k-r-edit-modal
                v-show="$route.query.editGoalId && $route.query.editKeyResultId"
                :goal="editGoal"
                @update="goalUpdated"
            ></l-goal-k-r-edit-modal>
            <!--/KR edit modal -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardHeadline from "@/components/LCardHeadline";
import LTabNavigation from "@/components/LTabNavigation";
import LSkeletonLoader from "@/components/LSkeletonLoader";
import LGoalsList from "@/components/LUserProfile/LGoalsList";
import LGoalKREditModal from "@/components/LGoalKREditModal";

export default {
    components: {
        LCardHeadline,
        LTabNavigation,
        LSkeletonLoader,
        LGoalsList,
        LGoalKREditModal,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
            tabs: [
                {
                    id: "my",
                    label: this.$t("goals.list.menuMyGoals"),
                },
                {
                    id: "team",
                    label: this.$t("goals.list.menuMyTeam"),
                },
                {
                    id: "companyTeam",
                    label: this.$t("goals.list.menuCompanyTeam"),
                },
                {
                    label: this.$t("profile.goals.btnExplore"),
                    href: "#/goals/list/all",
                    testId: "goals-module-link",
                },
            ],
            selectedTab: {
                id: "my",
            },
        };
    },
    computed: {
        ...mapGetters({
            goals: "goals/goals/list",
        }),
        editGoal() {
            const goalId = this.$route.query.editGoalId;

            return this.goals?.find(g => g._id === goalId) || {};
        },
    },
    mounted() {
        this.loadData();
    },
    methods: {
        goalUpdated() {
            // Goal progress calculation only happens on the server, so we need to reload the whole list
            // once the modal is closed.
            //
            // To avoid displaying a loading state, we directly dispatch the action here.
            //
            this.$store.dispatch("goals/goals/getList", {
                payload: {
                    listCustomFilter: {},
                    listSegment: this.selectedTab.id,
                    output: "profile",
                },
            });
        },
        async loadData() {
            this.isLoading = true;

            try {
                await this.$store.dispatch("goals/goals/getList", {
                    payload: {
                        listCustomFilter: {},
                        listSegment: this.selectedTab.id,
                        output: "profile",
                    },
                });
            } finally {
                this.isLoading = false;
            }
        },
        onTabSelect() {
            this.loadData();
        },
    },
};
</script>
